import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import SectionHeader from "../components/molecules/SectionHeader"
import Layout from "../components/layout"
import Reactmarkdown from "react-markdown"
import SEO from "../components/seo"
import "../styles/privacy.scss"
const query = graphql`
  {
    strapiPrivacy {
      privacyContent {
        text
      }
      privacyIntro {
        description
        header {
          subtitle
          title
        }
      }
    }
  }
`

const IndexPage = () => {
  const data = useStaticQuery(query)
  const intro = data.strapiPrivacy.privacyIntro
  const content = data.strapiPrivacy.privacyContent

  return (
    <Layout className="privacy">
      <section className="section section--privacyIntro">
        <div className="wrapper wrapper--narrow">
          <SectionHeader type="h1" subtitle={intro.header.subtitle}>
            {intro.header.title}
          </SectionHeader>
          <Reactmarkdown source={intro.description} />
        </div>
      </section>
      <section className="section section--privacyDate">
        <div className="wrapper wrapper--narrow">
          <div className="privacy__date">
            Effective date: <span>09/2020</span>
          </div>
          <div className="privacy__subject">
            Privacy policy of <span>adchitects.co</span>
          </div>
        </div>
      </section>
      {content.map((elements, i) => {
        return (
          <section
            key={i}
            className="section section--privacyContent"
            className={`section section--privacyContent ${
              i === 0 ? "section--privacyContent__first" : ""
            }`}
          >
            <div className="wrapper wrapper--narrow">
              <div className="privacy__container">
                <Reactmarkdown key={i} source={elements.text} />
              </div>
            </div>
          </section>
        )
      })}
    </Layout>
  )
}
export default IndexPage
